import React from 'react'
import HighlightText from '/js/views/shared/components/highlight/highlightText'
import HighlightSVG from '/js/views/shared/components/highlight/highlightSvg'
import HighlightQuote from '/js/views/shared/components/highlight/highlightQuote'
import HighlightStat from '/js/views/shared/components/highlight/highlightStat'

class Highlight extends React.Component {
  renderContent() {
    const { theme } = this.props
    const { content } = this.props.item

    switch (content.type) {
      case 'text':
        return <HighlightText content={content} theme={theme} />
      case 'animatedMap':
        return (
          <HighlightSVG content={content} theme={theme} type={content.type} />
        )
      case 'animatedSvgLineGraph':
        return (
          <HighlightSVG content={content} theme={theme} type={content.type} />
        )
      case 'animatedSvgCircleGraph':
        return (
          <HighlightSVG content={content} theme={theme} type={content.type} />
        )
      case 'quote':
        return <HighlightQuote content={content} theme={theme} />
      case 'stat':
        return <HighlightStat content={content} theme={theme} />
      default:
        return (
          <p className="font-sans text-granite-gray text-18">
            {`Wrong Content Type! It came back as ${content.type}. Check to ensure you are using the correct one.`}
          </p>
        )
    }
  }

  render() {
    const { item, styles } = this.props
    const { youtubeID } = this.props.item.content

    return (
      <div
        data-label="highlight"
        className={`
          flex
          ${!!youtubeID ? 'items-top' : 'items-center'}
          justify-center
          px-15
          py-75
          md:py-25
          lg:py-48
          w-full
          md:w-${item.width}
          border-columbia-blue
          border-b
          md:border
          md:border-r-0
          md:border-b-0
          ${styles}`}
      >
        {this.renderContent()}
      </div>
    )
  }
}

export default Highlight
